import React, { Component } from "react";
import TournamentList from "../components/TournamentList";
import { withRouter } from "react-router-dom";
import NoTournamentsMessage from "../components/NoTournamentsMessage";
import NoConnectionDialog from "../components/NoConnectionDialog";
import HeaderBar from "../components/header/HeaderBar";
import PageErrorBoundary from "../components/PageErrorBoundary";
import SupportDrawer from "../components/SupportDrawer";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { languages } from "../constants/languages";
import { GET_CHECKOUT_AUTH_URL_ENDPOINT } from "../util/OpenUpgradeCheckout";

const styles = (theme) => ({
  content: {
    [theme.breakpoints.up("md")]: {
      flexGrow: 1,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: 0,
    },
  },
  contentShift: {
    [theme.breakpoints.up("md")]: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 310,
    },
  },
});

class TournamentListContainer extends Component {
  state = {
    tournaments: [],
    tournamentsLoaded: false,
    present: false,
    tenSecondsPassed: false,
    sharedTournaments: [],
    sharedTournamentsLoaded: false,
    supportOpen: false,
    userStatus: {},
    userStatusLoaded: false,
  };

  handleDrawerOpen = () => {
    this.setState({ supportOpen: true });
  };

  handleDrawerClose = () => {
    this.setState({ supportOpen: false });
  };

  loadUserStatus = (uid) => {
    this.unsubscribUserStatus = window.firebase
      .firestore()
      .collection("userStatus")
      .doc(uid)
      .onSnapshot((doc) => {
        let userStatus = doc.data();
        this.setState({ userStatus: userStatus || {}, userStatusLoaded: true });
      });
  };

  UNSAFE_componentWillMount = () => {
    this.loadUserStatus(this.props.user.uid);

    this.unsubscribe = window.firebase
      .firestore()
      .collection("tournaments")
      .where("uid", "==", this.props.user.uid)
      .onSnapshot((querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach(function (doc) {
          let tournament = doc.data();
          tournament[".key"] = doc.id;
          if (tournament.new !== true) {
            tournaments.push(tournament);
          }
        });
        tournaments.sort((a, b) => b.date - a.date);
        this.setState({ tournaments: tournaments, tournamentsLoaded: true });
      });

    this.unsubscribe2 = window.firebase
      .firestore()
      .collection("checkPresence")
      .onSnapshot((querySnapshot) => {
        let present = false;
        if (!querySnapshot.empty) {
          present = true;
        }
        this.setState({ present: present });
      });

    this.unsubscribe3 = window.firebase
      .firestore()
      .collection("tournaments")
      .where("admins", "array-contains", this.props.user.uid)
      .onSnapshot((querySnapshot) => {
        let tournaments = [];
        querySnapshot.forEach(function (doc) {
          let tournament = doc.data();
          tournament[".key"] = doc.id;
          tournaments.push(tournament);
        });
        tournaments.sort((a, b) => b.date - a.date);
        this.setState({
          sharedTournaments: tournaments,
          sharedTournamentsLoaded: true,
        });
      });

    this.timeout = setTimeout(() => {
      this.setState({ tenSecondsPassed: true });
    }, 10000);
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeout);
    this.unsubscribe();
    this.unsubscribe2();
    this.unsubscribe3();
  };

  handleTournamentClick = (e, tournamentId) => {
    e.preventDefault();
    this.props.history.push("tournament/" + tournamentId + "/settings");
  };

  handleFeaturesClick = (e) => {
    e.preventDefault();
    this.props.history.push("/features");
  };

  generateProps = () => ({
    ...this.state,
    user: this.props.user,
    handleTournamentClick: this.handleTournamentClick,
    userData: this.props.userData,
  });

  handleClickUpgrade = async () => {
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("upgrade_button_list_pressed");
    }
    
    // TODO: First fetch the url and await, then enable a button to open the url in a new tab. 
    // This is to avoid popup blockers.
    
    try {
      const token = await window.firebase.auth().currentUser?.getIdToken();
      const response = await fetch(
        GET_CHECKOUT_AUTH_URL_ENDPOINT,
        {
          method: "POST",
          body: JSON.stringify({
            data: {
              locale: languages.getLanguage(),
              product: "professional", // worldclass, legendary, community
              redirect_url: "/legacy/checkout"
            }
          }),
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const json = await response.json();
      const url = json.result?.url;
      if (url) window.open(url, "_blank");
    } catch(error) {
      console.error("Error fetching checkout auth URL:", error);
    }
  }

  render() {
    const classes = this.props.classes;
    const props = this.generateProps();
    if (this.state.tenSecondsPassed && !this.state.present) {
      return <NoConnectionDialog open={true} />;
    } else {
      return (
        <div>
          <HeaderBar
            user={this.props.user}
            handleOpen={this.handleDrawerOpen}
            handleClose={this.handleDrawerClose}
            drawerOpen={this.state.supportOpen}
            userData={this.props.userData}
            userStatus={this.state.userStatus}
            handleClickUpgrade={this.handleClickUpgrade}
          />
          <SupportDrawer
            open={this.state.supportOpen}
            handleClose={this.handleDrawerClose}
            handleFeaturesClick={this.handleFeaturesClick}
          />
          <main
            className={classNames(classes.content, {
              [classes.contentShift]:
                this.state.supportOpen && this.state.selectedScreen !== "new",
            })}
          >
            <PageErrorBoundary
              resetKey={
                this.props.location.pathname + this.props.location.search
              }
            >
              {this.state.tournaments.length > 0 ||
              this.state.sharedTournaments.length > 0 ? (
                <TournamentList {...props} />
              ) : (
                this.state.tournamentsLoaded && (
                  <NoTournamentsMessage {...props} />
                )
              )}
            </PageErrorBoundary>
          </main>
        </div>
      );
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(TournamentListContainer)
);
